import React, { forwardRef, useState, useRef, useEffect } from "react";
import { ClickAwayListener } from "@material-ui/core";
import "./customSingleSelect.scss";
import loaderIcon from "../../../../assets/loader_check_206d4a52 (1).gif";
import errorIcon from "../../../../assets/cross-error.svg";
import tick from "../../../../assets/tick1.svg";
import { CUSTOM_BUTTON_STATUS } from "../../ERXConstants/constants";

const CustomSingleSelect = forwardRef((props, ref) => {
  const {
    title,
    placeholder,
    type,
    value,
    options,
    maxLimit,
    button_status,
    handleOnChangeInput,
    handleCloseDropdown,
    handleSelect,
    handleSaveCustomData,
  } = props;

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState("bellow");
  const inputDivRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    handleOpenDropdown();
    setMenuIsOpen(true);
  }, [options]);

  const handleOnChange = (e) => {
    setMenuIsOpen(false);
    handleOnChangeInput(e);
  };

  const handleOpenDropdown = () => {
    if (!inputDivRef.current || !dropdownRef.current) return;

    const inputRect = inputDivRef.current.getBoundingClientRect();
    const dropdownRect = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - inputRect.bottom;
    const spaceAbove = inputRect.top;
    const dropdownHeight = dropdownRect.height;

    let position = "bottom";
    if (dropdownHeight > spaceBelow && spaceBelow < spaceAbove) {
      position = "top";
    }
    setDropdownPosition(position);
  };

  const handleClose = () => {
    setMenuIsOpen(false);
    handleCloseDropdown();
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        handleClose();
      }}
    >
      <div className="custom-single-select-container">
        {title && <div className="custom-single-select-title">{title}</div>}

        <div style={{ position: "relative" }} ref={inputDivRef}>
          <div className="custom-single-select-input">
            {type === "textarea" ? (
              <textarea
                placeholder={placeholder}
                value={value}
                onChange={handleOnChange}
                maxLength={maxLimit}
                rows={3}
                ref={ref}
              />
            ) : (
              <input
                placeholder={placeholder}
                type={type}
                value={value}
                onChange={handleOnChange}
                maxLength={maxLimit}
                ref={ref}
              />
            )}
            {button_status === CUSTOM_BUTTON_STATUS.SAVE && (
              <span
                className="dm-save-btn"
                onClick={() => {
                  setMenuIsOpen(false);
                  handleSaveCustomData();
                }}
              >
                Save
              </span>
            )}
            {button_status === CUSTOM_BUTTON_STATUS.SUCCESS && (
              <img
                src={tick}
                alt=""
                width={19}
                height={15}
                style={{ marginRight: "2px" }}
              />
            )}
            {button_status === CUSTOM_BUTTON_STATUS.LOADING && (
              <img src={loaderIcon} alt="" width={25} height={15} />
            )}
            {button_status === CUSTOM_BUTTON_STATUS.ERROR && (
              <img src={errorIcon} alt="" width={20} height={15} />
            )}
          </div>

          <div
            className={`custom-single-select-dropdown-cont ${
              dropdownPosition === "top"
                ? "cssc-dropdown-up"
                : "cssc-dropdown-down"
            } ${
              value && menuIsOpen && options?.length > 0
                ? ""
                : "cssc-dropdown-display-hidden"
            }`}
            ref={dropdownRef}
          >
            {options.map((data, dataIndex) => (
              <div
                className="custom-single-select-dropdown-options"
                key={dataIndex}
                onClick={() => {
                  handleSelect(data);
                  handleClose();
                }}
              >
                {data?.title}
              </div>
            ))}
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
});

export default CustomSingleSelect;
